import caAPI from "../services/caAPI";

const checkTemplateModulo = (moduloId, atendimentoAtivo) => {
    if(atendimentoAtivo.oportunidade){
        return [1, 6].includes(Number(moduloId));
    } else if(atendimentoAtivo.processo) {
        return [2, 6, 8, 9].includes(Number(moduloId));
    }
    return Number(moduloId) == 6;
}

const checkTemplateTipoAtendimento = (templateTipos, atendimentoAtivo) => {
    return templateTipos.some((element) => element.id === atendimentoAtivo.tipo_atendimento.id);
}

export const templatesFilter = (templates, atendimentoAtivo) =>{ 
    const idUsuario = Number(caAPI.getLocalState('idUsuario'))
    let templatesFiltered = [];
    if(!atendimentoAtivo?.origem?.id_contato_origem){
        return templatesFiltered;
    }
    templatesFiltered = templates.filter((template)=>{ 
        if(
            template?.contato_origem?.length && 
            !template.contato_origem.map(contatoOrigem => contatoOrigem.id_contato_origem).includes(atendimentoAtivo.origem.id_contato_origem)) {
            return false;
        }
        if(template?.id_modulo_tags && !checkTemplateModulo(template.id_modulo_tags, atendimentoAtivo)) {
            return false;
        }
        if(template?.tipos?.length && !checkTemplateTipoAtendimento(template.tipos, atendimentoAtivo)){
            return false;
        }     
        if(template?.atendentes?.length && !template.atendentes.map(idAtendente => Number(idAtendente)).includes(idUsuario)) {
            return false
        }
        return template;
    })    
    return templatesFiltered;    
}

